const ALLOWED_EMAILS = process.env.REACT_APP_MIGRATION_ALLOWED_EMAILS;

export function canAccessMigration(profile) {
  if (!profile) return false;

  if (ALLOWED_EMAILS) {
    const allowlist = ALLOWED_EMAILS.split(',').map(e =>
      e.trim().toLowerCase()
    );
    if (allowlist.includes(profile.email?.toLowerCase())) return true;
  }

  return profile.pro >= 1;
}

export const TOTAL_STEPS = 24;

export const V2_DASHBOARD_URL =
  process.env.REACT_APP_V2_DASHBOARD_URL || 'https://dash.offstore.me';

export function getProgressPercent(completedSteps) {
  if (!completedSteps || !completedSteps.length) return 0;
  return Math.round((completedSteps.length / TOTAL_STEPS) * 100);
}

export function getStepLabel(currentStep) {
  const labels = {
    createUser: 'Criando usuário...',
    createStore: 'Criando loja...',
    migratePreferences: 'Migrando preferências...',
    migrateAddress: 'Migrando endereço...',
    migrateAttributes: 'Migrando atributos...',
    migrateCategories: 'Migrando categorias...',
    migrateProducts: 'Migrando produtos...',
    migrateMedia: 'Migrando imagens...',
    migrateCustomers: 'Migrando clientes...',
    migrateOrders: 'Migrando pedidos...',
    migrateCoupons: 'Migrando cupons...',
    migrateShippingManual: 'Migrando frete...',
    migrateShippingCustom: 'Migrando frete personalizado...',
    migrateShippingZones: 'Migrando zonas de frete...',
    migrateShippingKm: 'Migrando frete por km...',
    migrateMelhorEnvio: 'Migrando Melhor Envio...',
    migratePaymentGateways: 'Migrando pagamentos...',
    migrateDomainPixels: 'Migrando domínio e pixels...',
    migratePages: 'Migrando páginas...',
    migrateBilling: 'Migrando plano...',
    migrateCategoryImages: 'Copiando imagens de categorias...',
    fillMediaFileSizes: 'Otimizando imagens...',
    validate: 'Validando dados...',
    syncDelta: 'Sincronizando novos dados...',
  };

  return labels[currentStep] || 'Processando...';
}
